/** The bank's fact sheet as a look-up table (screens §A1): open on the first question, folded to one line on every later one. */
import { isMobileBand, useBand } from "../theme/breakpoints";
import { factRows, termNotes } from "./factSheet";

export function FactSheet({ bankName, text, open }: { readonly bankName: string; readonly text: string; readonly open: boolean }) {
  // On a phone the question comes first: the facts wait one tap away.
  const folded = isMobileBand(useBand());
  const rows = factRows(text);
  const notes = termNotes(text);
  return (
    <details className="gx-ci-facts" open={open && !folded} key={open && !folded ? "open" : "folded"}>
      <summary><span className="gx-eyebrow">About {bankName}</span></summary>
      <div data-testid="check.factSheet">
        <table className="gx-ci-fact-table"><tbody>
          {rows.map((r) => <tr key={r.label + r.value}><th scope="row">{r.label}</th><td className="gx-num">{r.value}</td></tr>)}
        </tbody></table>
        {notes.length === 0 ? null : <p className="gx-small gx-muted" data-testid="check.factNotes">{notes.join(" · ")}</p>}
      </div>
    </details>
  );
}
